import React, { useState, useEffect, useMemo } from 'react';
import { flowRight, get } from 'lodash';
import { connect, useDispatch } from 'react-redux';
import { setItem } from 'api/actions';
import PropTypes from 'prop-types';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import StatusIcon from 'modules/common/components/StatusIcon';
import ToggleFetcherTimer from 'modules/common/components/ToggleFetcherTimer';
import Content from './Content';
import * as actions from '../actions';
import * as c from '../constant';

const initialFormData = {
  transaction_status: '',
  year: '',
  keyword: '',
  q: '',
};

const statusOptions = [
  { label: 'ALL STATUS', value: '' },
  { label: 'ONGOING', value: 'ONGOING' },
  { label: 'PENDING', value: 'PENDING' },
  { label: 'VERIFIED', value: 'VERIFIED' },
  { label: 'REJECTED', value: 'REJECTED' },
  {
    label: 'ASSESSED BY PLANNING DEPARTMENT',
    value: 'ASSESSED BY PLANNING DEPARTMENT',
  },
  {
    label: 'ASSESSED BY ENGINEERING DEPARTMENT',
    value: 'ASSESSED BY ENGINEERING DEPARTMENT',
  },
  { label: 'ASSESSED BY BPLO', value: 'ASSESSED BY BPLO' },
  { label: 'PAID', value: 'PAID' },
  {
    label: 'FOR ACCOUNT CREATION',
    value: 'ASSESSED BY ENGINEERING DEPARTMENT',
  },
];

function Applications({
  getList,
  list,
  getItem,
  match,
  pager,
  isLoading,
  history,
  permissions,
}) {
  const profile = sessionStorage.getItem('profile')
    ? JSON.parse(sessionStorage.getItem('profile'))
    : {};
  const [formData, setFormData] = useState(initialFormData);
  const [refreshList, setRefreshList] = useState('');
  const [filter, setFilter] = useState(initialFormData);
  const [countChar, setCountChar] = useState(0);

  const dispatch = useDispatch();

  const getType = () => {
    if (match.params.transaction_type.toUpperCase() === 'RENEWAL') {
      return 'RENEWAL';
    }
    return 'NEW';
  };

  const param = {
    module_type: 'EBPLS',
    q: formData.keyword,
    sort_by: 'asc',
    transaction_status: filter.transaction_status,
    year: filter.year,
    transaction_type: getType(),
    latest_group_id: 1,
  };

  const debouncedSearchTerm = useDebounce(formData, 500);

  const formattedStatusOptions = useMemo(() => {
    if (profile.roles === 'BPLO') {
      return statusOptions.filter(
        (item) => item.label !== 'ASSESSED BY ENGINEERING DEPARTMENT'
      );
    }
    return statusOptions.filter(
      (item) => item.label !== 'FOR ACCOUNT CREATION'
    );
  }, []);

  useEffect(() => {
    if (refreshList) {
      getItem(refreshList);
    }
    setRefreshList('');
    if (debouncedSearchTerm && countChar >= 3) {
      setFilter({
        ...filter,
        keyword: formData.keyword,
        transaction_type: getType(),
      });
    } else {
      setFilter({
        ...filter,
        transaction_type: getType(),
      });
    }
    getList(param);
  }, [
    `${Object.values(filter).join(',')}`,
    getType(),
    debouncedSearchTerm,
    refreshList,
  ]);

  const onSetKeyWord = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  const onSetStatusFilter = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
    });
  };

  const onResetStatusFilter = () => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      keyword: '',
      transaction_status: '',
      year: '',
    }));
  };

  useEffect(() => {
    // reset search field if user select different application tab (new, renew, change... etc)
    setFormData({
      ...formData,
      keyword: '',
      q: '',
    });

    // reset filter status to default
    setFilter((prevFilter) => ({
      ...prevFilter,
      keyword: '',
      transaction_status: '',
      year: '',
    }));
  }, [getType()]);

  const onCallbackTimer = () => {
    getList({
      module_type: 'EBPLS',
      q: formData.keyword,
      transaction_status: filter.transaction_status,
      year: filter.year,
      transaction_type: getType(),
      latest_group_id: 1,
    });
  };

  useEffect(() => {
    dispatch(setItem(c.CALLBACK_TIMER, onCallbackTimer));
  }, [getType()]);

  return (
    <div className="card-content-listing  pt-1 pl-0">
      {Acl(permissions, ['EBPLS AUTO REFRESH']) && (
        <div className="transmital">
          <ToggleFetcherTimer callback={onCallbackTimer} />
        </div>
      )}
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            statusOptions={formattedStatusOptions}
            // notificationListConfig={bplsNotification}
            moduleName="Applications"
            getData={getList}
            setParams={param}
            setKeyword={onSetKeyWord}
            setStatusFilter={onSetStatusFilter('transaction_status')}
            setYearFilter={onSetStatusFilter('year')}
            resetStatusFilter={onResetStatusFilter}
            sideBarFilter
            status={get(filter, 'transaction_status') || ''}
            keyword={get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Transaction..."
            pathName={`${match.path}/:id?`}
            listName="Application"
            label="Application List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="transaction-list-company">
                  {get(
                    item,
                    'included.ebplsApplication.attributes.business_name'
                  )}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {get(
                    item,
                    'included.ebplsApplication.attributes.tracking_number'
                  ) || ''}
                </h4>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {get(item, 'included.ebplsApplication.attributes.bin') || ''}
                </h4>
                <div className="mt-1">
                  <StatusIcon
                    value={get(item, 'attributes.transaction_status')}
                  />
                </div>
              </div>
            )}
            isLoading={isLoading}
            // statusFilter
            selected={params.id}
            data={list}
            dataPager={pager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:ebpls_id?`}
                    render={() => (
                      <Content list={list} refreshList={setRefreshList} />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:ebpls_id?`}
                  render={() =>
                    !params.ebpls_id && list.length > 0 ? (
                      <Redirect to={`${match.url}/${get(list, '0.id')}`} />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

const mapStateToProps = ({ api }) => {
  return {
    list: get(api, `${c.LIST}.list`) || [],
    pager: get(api, `${c.LIST}.pager`) || {},
    isLoading: api.loading.indexOf(c.LIST) > -1,
    permissions: getJson('permissions'),
  };
};

const enhance = flowRight([withRouter, connect(mapStateToProps, actions)]);

Applications.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

export default enhance(Applications);
